var g = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var a = (o, m, r) => m in o ? g(o, m, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[m] = r, f = (o, m) => {
  for (var r in m || (m = {}))
    n.call(m, r) && a(o, r, m[r]);
  if (i)
    for (var r of i(m))
      s.call(m, r) && a(o, r, m[r]);
  return o;
};
var d = (o, m) => {
  var r = {};
  for (var p in o)
    n.call(o, p) && m.indexOf(p) < 0 && (r[p] = o[p]);
  if (o != null && i)
    for (var p of i(o))
      m.indexOf(p) < 0 && s.call(o, p) && (r[p] = o[p]);
  return r;
};
import { jsx as O } from "react/jsx-runtime";
import N from "../../../node_modules/prop-types/index.es.js";
import c from "react";
import { COMPONENT_SIZE as l, ICON_COMPONENT_SIZE as y } from "../../../constants/sizes.es.js";
import * as T from "./style.es.js";
import { Loading as E } from "./style.es.js";
import { Ring as L } from "./Ring/Ring.es.js";
const t = c.forwardRef((p, r) => {
  var e = p, {
    size: o = l.md
  } = e, m = d(e, [
    "size"
  ]);
  return /* @__PURE__ */ O(E, { size: o, ref: r, children: /* @__PURE__ */ O(L, f({ size: o }, m)) });
}), P = {
  size: N.oneOf(Object.values(y))
};
t.S = T;
t.displayName = "Loading";
t.propTypes = P;
export {
  t as Loading,
  P as loadingPropTypes
};
//# sourceMappingURL=Loading.es.js.map
